export enum Acquirer {
  AdsCa = 'ADS_CA',
  AdsUs = 'ADS_US',
  AnzNz = 'ANZ_NZ',
  AsbNz = 'ASB_NZ',
  BarclaysUK = 'BARCLAYS_UK',
  BnzNz = 'BNZ_NZ',
  ChaseUS = 'CHASE_US',
  CuscalAu = 'CUSCAL_AU',
  FdrcCa = 'FDRC_CA',
  FdrcUs = 'FDRC_US',
  FiservAu = 'FISERV_AU',
  Intercard = 'INTERCARD',
  IntercardEuIcpp = 'INTERCARD_EU_ICPP',
  IntercardEuRegular = 'INTERCARD_EU_REGULAR',
  IntercardUkIcpp = 'INTERCARD_UK_ICPP',
  IntercardUkRegular = 'INTERCARD_UK_REGULAR',
  KiwibankNz = 'KIWIBANK_NZ',
  Landsbankinn = 'LANDSBANKINN',
  NabAu = 'NAB_AU',
  NetsSdi = 'NETS_SDI',
  None = '',
  OpOnlinePayment = 'OP_ONLINE_PAYMENT',
  Other = 'OTHER',
  Swedbank = 'SWEDBANK',
  SwedbankSeAdvanced = 'SWEDBANK_SE_ADVANCED',
  SwedbankSeAdvancedLidl = 'SWEDBANK_SE_ADVANCED_LIDL',
  SwedbankSeAdvancedMcd = 'SWEDBANK_SE_ADVANCED_MCD',
  SwedbankSeClassicLidlDk = 'SWEDBANK_SE_CLASSIC_LIDL_DK',
  SwedbankSeClassicLidlFi = 'SWEDBANK_SE_CLASSIC_LIDL_FI',
  SwedbankSeClassicLidlSe = 'SWEDBANK_SE_CLASSIC_LIDL_SE',
  TillAu = 'TILL_AU',
  Unzer = 'UNZER',
  VerifoneEU = 'VERIFONE_EU',
  VerifoneEuRegular = 'VERIFONE_EU_REGULAR',
  VerifoneUK = 'VERIFONE_UK',
  VerifoneUkRegular = 'VERIFONE_UK_REGULAR',
  WestpacAu = 'WESTPAC_AU',
  WestpacNz = 'WESTPAC_NZ',
  WorldpayUS = 'WORLDPAY_US',
}
